import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Spin, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗 
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import trans from './translation';
import './userAccountManagementStudent.css';
import UploadModal from './uploadModal';
const { TabPane } = Tabs;
const UserAccountManagementStudent = (props) => {
    const messageRef = useRef(); 
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [flagModel, setFlagModel] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [funcList, setFuncList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, current, flag, isShowMsg) => {
        setTables([
            {
                studentId: "S100001",
                studentName: "Chan Siu Ming",
                studentEPlatformId: "SE10001",
                department: "Computing",
                programme: "Computer Science",
                admissionYear: "2024",
                inactiveDate:"",
                status: "Active",
            },
        ]);

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: 'Y' });
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }
    const download = (content) => {
        setIsUpload(true)
        setFlagModel(content)
    }

    const update = (model, e) => {
        messageShowHandler();
        // searchById();

        initForm({
            studentId: "S100001",
            studentSurname: "Chan Siu Ming",
            studentGivenName: "Chan Siu Ming",
            studentEPlatformId: "SE10001",
            department: "Computing",
            programme: "Computer Science",
            admissionYear: "2024",
            inactiveDate:"",
            birth: "2024/03",
            email: "tmchan@thei.edu.hk",
            status: "1",
        });
        setFlag("edit");
        setTabIndex("2");
    }


    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            studentId: model.studentId ?? "",
            studentSurname: model.studentSurname ?? "",
            studentGivenName: model.studentGivenName ?? "",
            studentEPlatformId: model.studentEPlatformId ?? "",
            department: model.department ?? "",
            programme: model.programme ?? "",
            admissionYear: model.admissionYear ?? "",
            inactiveDate: model.inactiveDate ? moment(new Date(model.inactiveDate), Config.dateFormatALL) : null,
            birth: model.birth ? moment(new Date(model.birth), Config.dateFormat6) : null,
            email: model.email ?? "",
            status: model.status ?? "",
            cohortYear: model.birth ? moment(new Date(model.birth), Config.dateFormat6) : null,
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        // setIsLoad(true);
        // setSpinInfo(trans.deleteData[Config.backLang]);
        // let deleteModel = checkboxState[0];
        // deleteModel.menuFuncId = Config.funcInfo.funcId;
        // Base.callBackApi("role/delete", deleteModel).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         cancel();
        //         search(pageSize, current, "Y", false);
        //         errFrameShow("success", trans.deleteSuccess[Config.backLang]);
        //         props.searchMenu(Config.userInfo.role);//刷新menu
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        // setIsLoad(true);
        // setSpinInfo(trans.dataBeSaving[Config.backLang])
        // let list = [];
        // for (let item of funcList) {
        //     if (item.children != null) {
        //         for (let iterator of item.children) {
        //             list.push(iterator);
        //             if (Base.isNotEmpty(iterator.children)) {
        //                 for (let subFunc of iterator.children) {
        //                     list.push(subFunc);
        //                 }
        //             }
        //         }
        //     }
        //     list.push(item);
        // }
        // values.funcList = list;
        // let url = "";
        // if (flag === "add") {
        //     url = "role/insert";
        // } else {
        //     url = "role/update"
        //     values.roleId = selectedRowKeys[0];
        //     values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        // }
        // values.menuFuncId = Config.funcInfo.funcId;
        // values.roleCode = values.roleCode.toLocaleUpperCase();
        // Base.callBackApi(url, values).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         searchById(data.object)
        //         errFrameShow("success", trans.saveSuccess[Config.backLang]);
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => {
        //     setIsLoad(false);
        //     props.searchMenu(Config.userInfo.role);
        // });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("role/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let roleModel = data.object;
                initForm(roleModel);
                setCheckboxState([roleModel]);
                setSelectedRowKeys([roleModel.roleId]);
                setFlag("edit");
                setFuncList(roleModel.funcList);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();

        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag) => {
        // if (flag) {
        //     if (!(Config.userInfo.role.roleCode === "SYS_ADMIN" || Config.userInfo.role.roleCode === "ADMIN") || searchModel.customerMgtId) {
        //         search(pageSize, 1, "N");
        //     }
        //     errFrameShow("success", trans.importSuccess[Config.backLang]);
        // }
        setIsUpload(false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Student ID',
            dataIndex: 'studentId',
            className: 'tableWidth10',
        },
        {
            title: 'Student Name',
            dataIndex: 'studentName',
            className: 'tableWidth10',
        },
        {
            title: 'Student ePlatform ID',
            dataIndex: 'studentEPlatformId',
            className: 'tableWidth15',
        },
        {
            title: "Department",
            dataIndex: 'department',
            className: 'tableWidth10',
        },
        {
            title: "Programme",
            dataIndex: 'programme',
            className: 'tableWidth12',
        },
        {
            title: "Admission Year",
            dataIndex: 'admissionYear',
            className: 'tableWidth10',
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth6',
        },
        {
            title: "Inactive Date",
            dataIndex: 'inactiveDate',
            className: 'tableWidth9',
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'tableWidth18 sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    return (
        <div id="container" className="template userAccountManagementStudent">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle userAccountManagementStudentSerchTitle">{trans.studentId[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.studentId || ''}
                                                placeholder={trans.studentId[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('studentId', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle userAccountManagementStudentSerchTitle">{trans.studentName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.studentName || ''}
                                                placeholder={trans.studentName[Config.backLang]}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('studentName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle userAccountManagementStudentSerchTitle">Cohort</div>
                                        <div className="sysSerchInput">
                                            <DatePicker.YearPicker placeholder="Cohort"
                                                className="parts-numberInput datePickerAllWidth"
                                                onChange={(value) => searchChange("cohortYear", value)}
                                                picker="month"
                                                format={Config.dateFormat7} />
                                        </div>
                                    </div>

                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {/* <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<EditOutlined />}>{trans.update[Config.backLang]}</Button> */}
                                <Button type="primary" className="sysBtn btnBlue" onClick={() => download("true")} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button>
                                <Button type="primary" className="sysBtn btnBlue"  onClick={() => download("false")} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>Batch Inactive </Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1450 }}
                                    rowKey="roleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.userAccountManagementStudent[Config.backLang]} forceRender={true}>
                            <Form form={form}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentId"
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                            >
                                                <Input type="text" placeholder={trans.studentId[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentSurname[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentSurname"
                                            >
                                                <Input type="text" placeholder={trans.studentSurname[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentGivenName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentGivenName"
                                            >
                                                <Input type="text" placeholder={trans.studentGivenName[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.studentEPlatformId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="studentEPlatformId"
                                            >
                                                <Input type="text" placeholder={trans.studentEPlatformId[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.department[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="department"
                                            >
                                                <Input type="text" placeholder={trans.department[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.programme[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="programme"
                                            >
                                                <Input type="text" placeholder={trans.programme[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.admissionYear[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="admissionYear"
                                            >
                                                <Input type="text" placeholder={trans.admissionYear[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.birth[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="birth"
                                            >
                                                <DatePicker placeholder=""
                                                    className="parts-numberInput datePickerAllWidth"
                                                    onChange={(value) => searchChange("startDate", value)}
                                                    picker="month"
                                                    format={Config.dateFormat6} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.email[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="email"
                                            >
                                                <Input type="text" placeholder={trans.email[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam ">{trans.status[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {context.userAccountManagementStudent.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam ">Cohort</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="cohortYear"
                                            >
                                                <DatePicker.YearPicker placeholder="Cohort"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    onChange={(value) => searchChange("cohortYear", value)}
                                                    picker="month"
                                                    format={Config.dateFormat7} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                   
                                    <div className='sysCol'>
                                        <div className="sysParam ">Inactive Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="inactiveDate"
                                            >
                                                <DatePicker placeholder="Inactive Date"
                                                    className="parts-numberInput datePickerAllWidth"
                                                    onChange={(value) => searchChange("inactiveDate", value)}
                                                   
                                                    format={Config.dateFormat5} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} flagModel={flagModel}/>}
        </div>
    )

}

export default UserAccountManagementStudent;